import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const saleService = {
  // Get all sales
  getSales: async () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/sales`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Get active sales
  getActiveSales: async () => {
    return axios.get(`${API_URL}/sales/active`);
  },

  // Get single sale
  getSale: async (id) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/sales/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Create sale
  createSale: async (saleData) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/sales`, saleData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': saleData instanceof FormData ? 'multipart/form-data' : 'application/json',
      },
    });
  },

  // Update sale
  updateSale: async (id, saleData) => {
    const token = localStorage.getItem('token');
    return axios.put(`${API_URL}/sales/${id}`, saleData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': saleData instanceof FormData ? 'multipart/form-data' : 'application/json',
      },
    });
  },

  // Delete sale
  deleteSale: async (id) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/sales/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default saleService;
